export const LOAD_PROPERTY_SPECIFICATIONS = "LOAD_PROPERTY_SPECIFICATIONS"

